import c, { applyTheme as d } from "@jetbrains/ring-ui-built/components/global/theme.js";
import { Theme as a } from "../components/Theme/ThemeContext.js";
const l = (t) => t === a.dark, s = (t) => t === a.auto, m = (t, e) => s(t) && e ? e : t, h = () => typeof window < "u" && !!window.matchMedia, p = (t, e, o) => {
  if (s(t))
    o.current && document.head.contains(o.current) && (document.head.removeChild(o.current), o.current = null);
  else if (o.current)
    o.current?.setAttribute("content", e);
  else {
    const r = document.querySelectorAll('meta[name="theme-color"]'), n = document.createElement("meta");
    n.name = "theme-color", n.content = e, o.current = n, r.length === 2 && r[0].before(n);
  }
}, b = (t) => {
  const { body: e } = document;
  e.classList.add("bodyQodanaBlocks"), l(t) ? (e.classList.add("bodyQodanaBlocks_dark"), d(c.DARK, e)) : (e.classList.remove("bodyQodanaBlocks_dark"), d(c.LIGHT, e));
};
export {
  m as getCurrentThemeColor,
  s as isAuto,
  l as isDark,
  h as isMatchMediaAvailable,
  b as updateBodyClass,
  p as updateMetaThemeColor
};
